import React from 'react';
import { formatErrorSupportDescription } from 'framework/utils';

const getErrorDescription = (error: Error, info: React.ErrorInfo) => {
  return formatErrorSupportDescription(error, info);
};

export default getErrorDescription;
